import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=5d9a7f0a&"
import script from "./AvatarMenu.vue?vue&type=script&lang=ts&"
export * from "./AvatarMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports